module.exports = __webpack_public_path__ + "static/random-coffee-2766aa153a3fb8c79187e9a88221454c.svg";